import { useEffect, useState } from "react";
import { Card, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { FaSave } from "react-icons/fa";
import { useAlertMessageContext } from "../../../contexts/alert-message.context";
import { useConfirmMessageContext } from "../../../contexts/confirm-message.context";
import cndService from "../../../services/cnd.service";
import { dateToString, notNullToDate } from "../../../utilities/auxiliary-functions";
import { removeFormatDate } from "../../../utilities/masks";
import { isEmpty } from "../../../utilities/validators";
import InfractionRecord from "../../records/infraction.record";
import { Button } from '@mui/material'
import { AlertMessageEnum } from "../../../utilities/types";
import { useTranslateContext } from "../../../contexts/translate.context";
import { usePartnerContext } from "../../../contexts/partner.context";
import authService from "../../../services/auth.service";

export interface IInfractionCondominiumFormProps {
    title: string,
    identifier: string,
    setRecord: any,
    viewOnly?: boolean
}

export const InfractionCondominiumForm: React.FC<IInfractionCondominiumFormProps> = (props: IInfractionCondominiumFormProps) => {

    const alertContext = useAlertMessageContext();
    const confirmContext = useConfirmMessageContext();
    const { display } = useTranslateContext();
    let { partner } = usePartnerContext();

    const [ invalidatedForm, setInvalidatedForm ] = useState(false);
    const [ isEditForm, setEditForm ] = useState(true);

    let reloadPage = false;
    const [ isLoading, setLoading ] = useState(false);
    const [ originRecord, setOriginRecord ] = useState({} as any);
    const [ sending, setSending ] = useState(false);

    /* TRATAMENTO PARTICULAR DO OBJETO QUE ESTA SENDO MANTIDO */
    // Infraction
    const [ infractionId, setInfractionId ] = useState(0);
    const [ estateId, setEstateId ] = useState(0);
    const [ launch, setLaunch ] = useState(dateToString(new Date(), 'dd/mm/yyyy')); 
    const [ name, setName ] = useState(''); 
    const [ reason, setReason ] = useState(''); 
    const [ justification, setJustification ] = useState(''); 
    const [ created, setCreated ] = useState(dateToString(new Date(), 'dd/mm/yyyy HH:MM:ss'));
    const [ updated, setUpdated ] = useState(dateToString(new Date(), 'dd/mm/yyyy HH:MM:ss'));

    const [ listEstate, setListEstate ] = useState([] as any);

    function fillRecord(infraction: any) {

        if (!isEmpty(infraction)) {
            setInfractionId(infraction.id);
            setEstateId(infraction.estateId);
            setLaunch(notNullToDate(infraction.launch, 'dd/mm/yyyy'));
            setName(infraction.name);
            setReason(infraction.reason);
            setJustification(infraction.justification);
            setCreated(notNullToDate(infraction.created, 'dd/mm/yyyy HH:MM:ss'));  
            setUpdated(notNullToDate(infraction.updated, 'dd/mm/yyyy HH:MM:ss'));  
        }
    } // fillRecord

    async function isValidForm() {
        let result = true;
        let emptyRequired = false;

        if (isEmpty(launch))
            emptyRequired = true;
        if (isEmpty(name))
            emptyRequired = true;
        if (isEmpty(reason))
            emptyRequired = true;
        /*
        if (isEmpty(fullname))
            emptyRequired = true;
        if (isEmpty(registrationPf))
            emptyRequired = true;
        if ((!isEmpty(registrationPf)) && (!isCpf(registrationPf))) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, display.message.invalid.registration_pf);
            result = false;
        }
        */

        if (emptyRequired) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, display.message.invalid.required);
            result = false;
        }

        setInvalidatedForm(!result);
        return result;
    } // isValidForm

    function onClick_CancelInfraction(event: any) {
        event.preventDefault();
        props.setRecord(event, 0);
    } // onClick_CancelInfraction

    function fillRegister() {

        const dataRegister = {
            id : infractionId,
            estateId, 
            partnerId: partner.id,
            launch, 
            name, 
            reason, 
            justification, 
            created : removeFormatDate(created), 
            updated : removeFormatDate(updated)
        };

        return dataRegister;
    } // fillRegister

    async function onClick_SaveInfraction(event: any) {
        event.preventDefault();
        
        const isValid = await isValidForm();
        if (isValid) {
            try {
                const isConfirmed = await confirmContext.show(props.title, display.message.confirm_record);
                if (isConfirmed) {
                    setSending(true);

                    const infraction = fillRegister();
                    if (infraction.id > 0)
                        await cndService.saveInfraction(infraction.id, infraction);
                    else
                        await cndService.createInfraction(infraction);

                    setSending(false);
                    await alertContext.show(AlertMessageEnum.SUCCESS, props.title, display.message.the_record_has_been_saved_successfully);
                    props.setRecord(event, 0);
                }
            } catch (error: any) {
                setSending(false);
                await alertContext.show(AlertMessageEnum.FAIL, props.title, error);
            }
        }
    } // onClick_SaveInfraction

    async function changeEstate() {
        const attributes = ['id','name'];
        const result = await cndService.estateList(attributes);
        setListEstate(result.rows);
    }

    async function searchParam() {
        try {
            setEditForm(!props.viewOnly);
            if (!Number.isNaN(Number.parseInt(props.identifier ||''))) {

                const infraction = await cndService.infractionById(Number(props.identifier));
                setOriginRecord(infraction);
                fillRecord(infraction);
            }
        } catch(error: any) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, error);
        }
    } // searchParam

    useEffect(() => {
        if (!isLoading && !reloadPage) {
            if (isEmpty(partner))
                // eslint-disable-next-line react-hooks/exhaustive-deps
                partner = authService.currentPartner();

            changeEstate();
            searchParam();
        }

        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            reloadPage = !reloadPage;
        }
    }, []); // useEffect

    function viewCadastreForm() {

        return (
            <Container fluid className="page-body infraction">
                <Row>
                    <Col sm={12} className="page-sweet">
                        <Card>
                            <Card.Header>
                                {(originRecord.created || originRecord.updated) && (
                                    <div className="form-identy-registry float-right">
                                        <span className="white-space"><b>Criação: </b> {dateToString(originRecord.created, 'dd/mm/yyyy HH:MM:ss')}</span>
                                        <span className="white-space"><b>Atualização: </b> {dateToString(originRecord.updated, 'dd/mm/yyyy HH:MM:ss')}</span>
                                    </div>
                                )}
                                <Card.Title>{display.legend.record}</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Form className="form" id="form-cadastre" validated={invalidatedForm}>
                                    <InfractionRecord
                                        title={props.title}
                                        isEdit={isEditForm}
                                        identifier={infractionId === 0}
                                        viewOnly={props.viewOnly}

                                        created={created}
                                        updated={updated}
                                        listEstate={listEstate}

                                        estateId={estateId}
                                        launch={launch}
                                        name={name}
                                        reason={reason}
                                        justification={justification}
                                        setEstateId={setEstateId}
                                        setLaunch={setLaunch}
                                        setName={setName}
                                        setReason={setReason}
                                        setJustification={setJustification}
                                    />
                                </Form>
                            </Card.Body>
                            <Card.Footer className="text-right">
                                <Button className="me-2" onClick={ (e) => onClick_CancelInfraction(e) } variant="contained" color="secondary">{display.buttom.cancel}</Button>
                                {!props.viewOnly && <Button onClick={ (e) => onClick_SaveInfraction(e) } disabled={sending} variant="contained" color="primary">
                                    { sending ? <Spinner className="me-2" as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : <FaSave className="me-2" size={22} /> } {' '}
                                    {display.buttom.save}
                                </Button>}
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    } // viewCadastreForm

    return (
        <>
            { viewCadastreForm() }
        </>
    );

}

export default InfractionCondominiumForm;
